import { render, staticRenderFns } from "./GrupoComponent.vue?vue&type=template&id=a0d59244&"
import script from "./GrupoComponent.vue?vue&type=script&lang=js&"
export * from "./GrupoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports